var _excluded = ["children", "color", "breakWord", "intent", "italic", "weight"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { StyledTypography } from './Typography.styles';
/**

 @since 10.19.0

 @see [Storybook](https://stories.core.procore.com/?path=/story/core-react_demos-typography--demo)

 */
export var Typography = /*#__PURE__*/React.forwardRef(function Typography(_ref, ref) {
  var children = _ref.children,
    color = _ref.color,
    breakWord = _ref.breakWord,
    intent = _ref.intent,
    italic = _ref.italic,
    weight = _ref.weight,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledTypography, _extends({
    $breakWord: breakWord,
    $color: color,
    $intent: intent,
    $italic: italic,
    $weight: weight
  }, props, {
    ref: ref
  }), children);
});
Typography.displayName = 'Typography';
//# sourceMappingURL=Typography.js.map